const storage = (key) => ({
  set: (value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get: () => {
    const value = localStorage.getItem(key);
    if (value === null || value === "undefined") return null;
    
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error(`Error parsing storage value for key "${key}":`, error);
      return null; // Return null if parsing fails
    }
  },
});

export default storage;
